import Input from "@components/Input";
import Textarea from "@components/Textarea";
import { Button, Collapse, Image } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers";
import { setData } from "reducers/data";

export default function Benefit() {
  const dispatch = useDispatch();
  const benefits = useSelector((state: RootState) => state.data.benefits);
  const [active, setActive] = useState<any>([]);

  const onChangeBenefit = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    const { name, value } = e.target;
    dispatch(
      setData({
        benefits: [
          ...benefits.slice(0, index),
          { ...benefits[index], [name]: value },
          ...benefits.slice(index + 1),
        ],
      })
    );
  };

  const onClickDelete = (index: number) => {
    dispatch(
      setData({
        benefits: [...benefits.slice(0, index), ...benefits.slice(index + 1)],
      })
    );
  };

  const onClickAdd = () => {
    dispatch(
      setData({
        benefits: [
          ...benefits,
          {
            benefitId: "",
            name: "새 베네핏",
            englishName: "",
            description: "",
            value: 10,
            landingValue: 0,
            imageUri: "",
            link: "",
          },
        ],
      })
    );
    setActive(benefits.length);
  };

  return (
    <div>
      <Collapse activeKey={active} onChange={(key) => setActive(key)}>
        {benefits.map((b, index) => (
          <Collapse.Panel header={b.name} key={index}>
            <Input
              label="아이디"
              hint="중복 X"
              inputProps={{
                name: "benefitId",
                value: b.benefitId,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Input
              label="이름"
              inputProps={{
                name: "name",
                value: b.name,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Input
              label="영어이름"
              inputProps={{
                name: "englishName",
                value: b.englishName,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Textarea
              label="설명"
              textareaProps={{
                name: "description",
                value: b.description,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Input
              label="링크"
              inputProps={{
                name: "link",
                value: b.link,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Input
              label="정렬값"
              inputProps={{
                name: "value",
                value: b.value,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Input
              label="랜딩페이지 정렬값"
              inputProps={{
                name: "landingValue",
                value: b.landingValue,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Input
              label="이미지"
              inputProps={{
                name: "imageUri",
                value: b.imageUri,
                onChange: (e) => onChangeBenefit(e, index),
              }}
            />
            <Image
              src={
                b.imageUri.startsWith("http")
                  ? b.imageUri
                  : `https://thegarage.kr${b.imageUri}`
              }
            />
            <br />
            <br />
            <Button type="dashed" onClick={() => onClickDelete(index)}>
              베네핏 제거
            </Button>
          </Collapse.Panel>
        ))}
      </Collapse>
      <br />
      <br />
      <Button onClick={onClickAdd}>베네핏 추가</Button>
    </div>
  );
}
